import React from 'react';
import { CustomSvgButtonWithText } from 'crazyEditor/components/EditorUI/BaseUI/index';
import * as Colors from 'material-ui/styles/colors';

export default (props) => (
  <CustomSvgButtonWithText {...props} iconColor={Colors.grey700}/>
);
